export const GET_GAME_ENGAGEMENT_PENDING = 'GET_GAME_ENGAGEMENT_PENDING';
export const GAME_ENGAGEMENT = 'GAME_ENGAGEMENT';

export const GAMES_ANALYTICS_GET_PENDING = 'GAMES_ANALYTICS_GET_PENDING';
export const GAMES_ANALYTICS = 'GAMES_ANALYTICS';
